import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import {
  GET_ALL_PERMISSIONS,
  CREATE_PERMISSION_NAME,
  EDIT_PERMISSION,
  DELETE_PERMISSION,
} from "./actionTypes"
import { getAllPermissions } from "./actions"
import { apiError } from "../actions"
import { changePreloader } from "../../store/layout/actions"
import {
  createPermissionCall,
  getAllPermissionsCall,
  editPermissionsCall,
  deletePermissionCall,
} from "../../helpers/repository"
import { getAllPermissionsResponseSuccess } from "./actions"
import { showMessage } from "components/Common/Toaster"
import { showErrorMessages } from "helpers/helpers"
import { getAllRoles } from "store/roles/actions"

function* attempGetAllPermissions() {
  try {
    yield put(changePreloader(true))
    const response = yield call(getAllPermissionsCall)
    yield put(getAllPermissionsResponseSuccess(response.data.data))
    yield put(changePreloader(false))
  } catch (error) {
    showErrorMessages(error)
  }
}
function* attempCreatePermission(action) {
  const { toggle } = action

  try {
    const response = yield call(createPermissionCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllPermissions())
    yield put(getAllRoles())
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}
// -------------------------------------------------------EDIT PERMISSION------------------------------------------------------
function* attempEditPermission(action) {
  const { toggle } = action

  try {
    const response = yield call(editPermissionsCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllPermissions())
    yield put(getAllRoles())
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}

// -------------------------------------------------------DELETE PERMISSION------------------------------------------------------
function* attempDeletePermission(action) {
  try {
    const response = yield call(deletePermissionCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllPermissions())
    yield put(getAllRoles())
  } catch (error) {
    showErrorMessages(error)
  }
}
function* permissionsSaga() {
  yield takeEvery(GET_ALL_PERMISSIONS, attempGetAllPermissions)
  yield takeEvery(CREATE_PERMISSION_NAME, attempCreatePermission)
  yield takeEvery(EDIT_PERMISSION, attempEditPermission)
  yield takeEvery(DELETE_PERMISSION, attempDeletePermission)
}

export default permissionsSaga
